import { useContext } from 'react';
import { Alert, IconWarning, Tooltip } from '@screentone/core';

import { SummarianContext } from 'contexts/summarian/SummarianContext';

export const SummarianWarning = () => {
  const { isSummarianReady, isSummarianRetrying } = useContext(SummarianContext);

  return isSummarianReady ? null : (
    <Tooltip>
      <Tooltip.Content position="bottom" size="lg">
        Summarian failed to load — alt-summ editing is unavailable.
        {isSummarianRetrying && ' Retrying in the background.'}
      </Tooltip.Content>
      <Tooltip.Trigger>
        <Alert type="warning" icon={IconWarning} inline>
          Failed to load Summarian
        </Alert>
      </Tooltip.Trigger>
    </Tooltip>
  );
};
